export enum BandeiraEnum {

    VISA ="VISA",
	  MASTERCARD = "MASTERCARD",
    AMEX = "AMEX",
    OUTROS = "OUTROS"

  }
